import {
  SESSION_ID_AGENT_HINT,
  SESSION_ID_TRANSCRIPT_HINT,
} from './AlertSecretDetails.helpers';

interface TranscriptAltLocation {
  when: string;
  path: string;
}

export interface SessionTranscriptHintProps {
  /** First line: the grouped-card hint, or the full session id on a row. */
  firstLine: string;
  firstLineClassName?: string;
  location?: string | null;
  altLocation?: TranscriptAltLocation | null;
}

/** Flat form of the transcript hint body, used as an accessible name. */
export function sessionTranscriptHintLabel({
  firstLine,
  location,
  altLocation,
}: SessionTranscriptHintProps): string {
  return [
    firstLine,
    location ? SESSION_ID_TRANSCRIPT_HINT : null,
    location ? `Location: ${location}` : null,
    altLocation ? `${altLocation.when}: ${altLocation.path}` : null,
    SESSION_ID_AGENT_HINT,
  ]
    .filter(Boolean)
    .join(' ');
}
